import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const MeetFounder = () => {
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/53257d18d934c13deb15172e6d977d0c36a3dd097c5c5cf609cb857dac040a3963b23aa6d7b2ab716a4b1aba01045119/images/aW1hZ2UvcG5n/86073368fa597368b31df5a13528b417.png";

  return (
    <section id="founder" className="py-32 px-4 relative overflow-hidden bg-[#030014]">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative order-2 lg:order-1"
          >
            <div className="absolute -inset-4 bg-gradient-to-tr from-purple-500/20 to-cyan-500/20 blur-3xl opacity-50" />
            <div className="relative glass-panel rounded-[3rem] p-10 md:p-16 border-white/5">
              <div className="flex items-center gap-6 mb-12">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-purple-500 to-cyan-500 p-1">
                  <div className="w-full h-full rounded-full bg-[#0a0515] flex items-center justify-center overflow-hidden">
                    <img 
                      src={logoUrl} 
                      alt="DaiKhoToken Logo" 
                      className="w-12 h-12 object-contain invert" 
                    />
                  </div>
                </div>
                <div>
                  <h3 className="text-3xl font-black text-white uppercase tracking-tighter">Brian Samelson</h3>
                  <p className="text-purple-400 font-bold uppercase tracking-[0.2em] text-xs">Founder, DAI KHO LIMITED™</p>
                </div>
              </div>

              <div className="space-y-6 text-slate-400 text-lg font-light leading-relaxed">
                <p>
                  I'm a published author, Reiki practitioner, entrepreneur, and lifelong student of personal growth.
                </p>
                <p>
                  My journey has taken me through public service, sales, spiritual practice, and blockchain technology, 
                  but every chapter has shared one common theme: 
                  <span className="text-white font-medium italic"> The transformation of adversity into purpose.</span>
                </p>
                <p>
                  As the author of <span className="text-white">Learning to Dream: Inner Journey to Self-Healing</span>, 
                  I explored the connection between dreams, consciousness, healing, and self-discovery. 
                  Those same ideas continue to inspire the vision behind DAI KHO today.
                </p>
                <p>
                  Whether I'm creating apparel, building the DaiKhoToken ecosystem, writing, or working with Reiki clients, 
                  my goal remains the same: To build something that helps people reconnect with themselves.
                </p>
              </div>

              <div className="mt-12 pt-12 border-t border-white/5">
                <p className="text-slate-500 italic">"Welcome to the journey."</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="order-1 lg:order-2"
          >
            <div className="inline-block px-4 py-1.5 rounded-full border border-pink-500/30 bg-pink-500/10 text-pink-300 text-[10px] font-bold tracking-widest uppercase mb-8">
              Literary Work
            </div>
            <h2 className="text-5xl md:text-7xl font-black mb-8 leading-none uppercase tracking-tighter">
              Learning <br /> to <span className="text-gradient">Dream.</span>
            </h2>
            <p className="text-slate-400 text-xl font-light mb-12">
              Explore the inner journey to self-healing through the foundational text of the DAI KHO philosophy.
            </p>

            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-pink-500 to-purple-600 rounded-2xl blur opacity-25 group-hover:opacity-75 transition duration-1000"></div>
              <a 
                href="https://www.amazon.com/Learning-Dream-Inner-Journey-Self-Healing-ebook/dp/B085XBB8L8" 
                target="_blank" 
                rel="noopener noreferrer"
                className="relative flex items-center gap-6 p-8 bg-black rounded-3xl border border-white/10 transition-all duration-300 hover:scale-[1.02] overflow-hidden"
              >
                <div className="w-20 h-28 bg-gradient-to-b from-[#1a1a1a] to-[#0a0515] rounded shadow-2xl flex items-center justify-center border border-white/10 shrink-0 relative group-hover:border-pink-500/50 transition-colors">
                  <img 
                    src={logoUrl} 
                    alt="Book Icon" 
                    className="w-12 h-12 object-contain invert opacity-40 group-hover:opacity-100 transition-opacity" 
                  />
                  <div className="absolute bottom-2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-pink-500/50 to-transparent" />
                </div>
                
                <div className="text-left relative z-10">
                  <p className="text-white font-bold text-xl mb-1">Learning to Dream</p>
                  <p className="text-slate-400 text-sm mb-4">Inner Journey to Self-Healing</p>
                  <div className="flex items-center gap-2 text-pink-400 font-bold uppercase tracking-widest text-[10px]">
                    Available on Amazon <SafeIcon name="ArrowRight" className="w-3 h-3" />
                  </div>
                </div>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MeetFounder;